import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function CreateComponent () {
  const history = useHistory();
  const [validated, setValidated] = useState(false);
  const [errorType, setErrorType] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [values, setValues] = useState({});
  const [file, setFile] = useState();

  function handleChangeValues (event) {
    setValues({ ...values, [event.target.name]: event.target.value });
  }
  function handleChangeFile (event) {
    const file2 = event.target.files[0];
    if (file2.type === 'image/jpeg'
      || file2.type === 'image/png'
      || file2.type === 'image/svg+xml') {
      setFile(file2);
      console.log('====================================');
      console.log('foi');
      console.log('====================================');
      setValues({ ...values, [event.target.name]: event.target.value });
    } else {
      showError();
      setFile();
      setValues({ ...values, [event.target.name]: '' });
    }
  }

  function showError () {
    setErrorType(true);
    setTimeout(() => setErrorType(false), 3000);
  }
  function handleSubmit (event) {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      const data = new FormData();
      data.set('thumbnail', file);
      data.set('name', values.name);
      data.set('description', values.description);
      data.set('route', values.route);

      api.post('/components', data)
        .then(() => {
          setValues({
            name: '',
            description: '',
            route: '',
          });
          setFile(null);
          setSuccess(true);
          const element = document.getElementById('msgSuccess');
          element.innerHTML = 'Componente cadastrado com sucesso';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    }
  }
  return (
    <div className="content-register-component">
      {errorType ? (
        <Error>
          <p>Formato inválido para o arquivo. Só são permitidos arquivos PNG, JPG/JPEG e SVG.'</p>
        </Error>
      ) : null}
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <Card>
        <Card.Header>
          <h5>Cadastrar componente</h5>
        </Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Nome</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.name}
                name="name"
                required
                type="text"
                placeholder="Entre com o nome do componente"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com nome
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formDescription">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.description}
                name="description"
                required
                type="text"
                placeholder="Entre com a descrição"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com a descrição
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formRoute">
              <Form.Label>Rota</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.route}
                name="route"
                required
                type="text"
                placeholder="Entre com a rota"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com a rota
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formRoute">

              <Form.File
                id="thumbnail"
                label="Thumbnail"
                onChange={handleChangeFile}
                value={values.thumbnail}
                name="thumbnail"
                required
              />

            </Form.Group>

            <Button block type="submit" variant="success">Cadastrar</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
